import { AppConfig } from "../models/AppConfig";

export const apiConfig: AppConfig = {
  apiUrl: import.meta.env.VITE_API_URL,
  apiSpec: "1.0",
  appName: "spa admin",
  loginScopes: ["openid", "profile", import.meta.env.VITE_API_SCOPE],
  tenantId: import.meta.env.VITE_TENANT_ID,
};
